import { render } from "./expertRec.vue?vue&type=template&id=24431cbb"
import script from "./expertRec.vue?vue&type=script&lang=js"
export * from "./expertRec.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__